import { jsx as _jsx } from "react/jsx-runtime";
import QRCode from 'react-qr-code';
/**
 * Компонент для генерации QR-кода из текста
 * Использует библиотеку react-qr-code для отображения QR-кода
 */
const QRCodeGenerator = ({ text, size = 256, fgColor = '#000000', bgColor = '#FFFFFF', level = 'L', title, className, style, }) => {
    if (!text) {
        return null;
    }
    return (_jsx("div", { className: className, style: style, children: _jsx(QRCode, { value: text, size: size, fgColor: fgColor, bgColor: bgColor, level: level, title: title }) }));
};
export default QRCodeGenerator;
